<formly-form
  class="configurable-form-container"
  [model]="model"
  [fields]="fieldConfig"
  [options]="formOptions"
  [form]="form"
  (modelChange)="onModelChange(model)"
></formly-form>
